function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n    .bubble_svg__bubble_svg__st0{fill:#484848}\n  ");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "bubble_svg__bubble_svg__Layer_2_1_"
}, /*#__PURE__*/React.createElement("g", {
  id: "bubble_svg__bubble_svg__Layer_1-2"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "bubble_svg__bubble_svg__st0",
  d: "M20.5,22.3c-0.2,0-0.3-0.1-0.5-0.2l-5.2-4.4H4.2c-1.5,0-2.6-1.2-2.6-2.6V4.7c0-1.5,1.2-2.6,2.6-2.6h16.6 c1.5,0,2.6,1.2,2.6,2.6v10.4c0,1.3-1,2.4-2.2,2.6v3.9c0,0.3-0.2,0.6-0.4,0.7C20.7,22.3,20.6,22.3,20.5,22.3z M4.2,3.6 c-0.6,0-1.1,0.5-1.1,1.1v10.4c0,0.6,0.5,1.1,1.1,1.1h10.9c0.2,0,0.3,0.1,0.5,0.2l4.2,3.5v-3c0-0.4,0.3-0.8,0.8-0.8h0.4 c0.6,0,1.1-0.5,1.1-1.1V4.7c0-0.6-0.5-1.1-1.1-1.1H4.2z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "bubble_svg__bubble_svg__st0",
  d: "M18.7,8.6H6.3c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8h12.4c0.4,0,0.8,0.3,0.8,0.8S19.1,8.6,18.7,8.6z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "bubble_svg__bubble_svg__st0",
  d: "M18.7,12.6H6.3c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8h12.4c0.4,0,0.8,0.3,0.8,0.8S19.1,12.6,18.7,12.6z"
}))));

function SvgBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bubble_svg__bubble_svg__Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
}

export default SvgBubble;